import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { AppSettings } from '@services/settings/app-settings.service';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { AuthService } from '@services/core/auth.service';
import { AppNavService } from '@services/core/app-nav.service';
import { PeriodService } from '../../../feature/management/billing-management/services/period.service';
import { CommonModule } from '@angular/common';
import { environment } from '@environments/environment';
import { SocketService } from '@services/core/socket.service';

@Component({
	selector: 'header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CommonModule]
})
export class HeaderComponent {
	protected logo = "assets/img/logo.webp"
	protected profilePhotoURL
	protected userData
	public appSettings = inject(AppSettings)
	readonly nav = inject(AppNavService)
	private authService = inject(AuthService)
	private authMicrosoft = inject(MicrosoftAuthService)
	private socketService = inject(SocketService)
	readonly periodService = inject(PeriodService)
	environment = environment;

	constructor() {
		effect(() => {
			this.userData = this.authService.userData();
			this.profilePhotoURL = this.authService.userPhoto();
		})
	}

	logout() {
		sessionStorage.setItem('fpv_hold_login', '1');
		this.authMicrosoft.logout().subscribe({
			next: () => this._finishLogout(),
			error: () => this._finishLogout()
		});
	}

	private _finishLogout() {
		this.socketService.announceBrowserSession('logout');
		this.authMicrosoft.clearSesion();
		window.location.assign('/');
	}
}
